const DEFAULT_NUMBER_FORMATTER = new Intl.NumberFormat()
const DEFAULT_DATE_FORMATTER = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric",
  timeZone: "UTC",
})
const DEFAULT_DATETIME_FORMATTER = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
})

export function formatNumber(value) {
  if (value === null || value === undefined) return "—"
  const num = Number(value)
  if (Number.isNaN(num)) return value
  return DEFAULT_NUMBER_FORMATTER.format(num)
}

export function formatDate(value) {
  if (!value) return "—"
  if (typeof value !== "string") return value
  const parts = value.split("-")
  if (parts.length !== 3) return value
  const [year, month, day] = parts.map((part) => Number.parseInt(part, 10))
  if (
    !Number.isFinite(year) ||
    !Number.isFinite(month) ||
    !Number.isFinite(day)
  ) {
    return value
  }
  const date = new Date(Date.UTC(year, month - 1, day))
  if (Number.isNaN(date.getTime())) return value
  return DEFAULT_DATE_FORMATTER.format(date)
}

export function formatDateTime(value) {
  if (!value) return "—"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "—"
  return DEFAULT_DATETIME_FORMATTER.format(date)
}
